import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import generatePath from '~client/settings/routing';
import ReconciliationDetail from '~pages/reconciliation/detail';
import ReconciliationList from '~pages/reconciliation/list';

const mapStateToProps = state => ({
  token: state.auth.getIn(['base', 'token']),
});

@connect(mapStateToProps, null)
export default class ReconciliationDashboard extends React.Component {
  render() {
    if (!this.props.token || this.props.token.length === 0) {
      return (
        <Redirect
          to={generatePath(
            'login',
            {},
            {
              redirectUrl: this.props.match.url,
            },
          )}
        />
      );
    }

    return (
      <div className="reconciliation-container" style={{ width: '100%', height: '100%' }}>
        <Route path="/reconciliation/" exact component={ReconciliationList} history />
        <Route path="/reconciliation/detail/:id" component={ReconciliationDetail} />
      </div>
    );
  }
}

ReconciliationDashboard.propTypes = {
  token: PropTypes.string.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
};

ReconciliationDashboard.defaultProps = {
  token: '',
  match: {
    url: '',
  },
};
